/*
    Description: get more posts -- click the show more button and get more posts for the site 
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/

//import utility class for ajax call
import Utilities from "./utilities";

//Posts class
class MorePosts extends Utilities{

    // constructor
    constructor({

        // init button class
        buttonClass = "--js-load-posts",

        // where to load our new posts
        targetContainer = "--js-dynamic-posts",

        // global loading gif
        loadingClass = "--loading",

        // class the individual posts are using
        postClass = "dynamic",

        // global hide class
        hideClass = "--hide",

        // data attributes labels
        dataPostNum = "data-postnum",
        dataPost = "data-post"
    
    } = {}){

        // get constructor/params from Utilities
        super();

        // set main button class to load more posts
        this.buttonClass = buttonClass;

        // get bttn DOM element
        this.button = (this.buttonClass) ?  document.querySelector(`.${this.buttonClass}`) : null;

        // get target container class
        this.targetClass = targetContainer;
        
        // get target container DOM element
        this.targetContainer = (this.targetClass) ?  document.querySelector(`.${this.targetClass}`) : null;

        // the post preview class
        this.postClass = postClass;

        // get currently loaded posts in our container
        this.initialPostLoad = (this.targetContainer && this.postClass) ? this.targetContainer.querySelectorAll(`.${this.postClass}`).length : 0;

        // get nonce element 
        this.nonce = document.getElementsByName("more-posts");

        // set loading class
        this.loading = loadingClass;

        // set hide class
        this.hide = hideClass;

        // get data attribute names
        this.dataPostNum = dataPostNum;
        this.dataPost = dataPost;

        // get post type
        this.postType = (this.targetContainer) ? this.targetContainer.getAttribute(this.dataPost) : null;

        // get total posts
        this.totalPosts = (this.targetContainer) ? (this.targetContainer.getAttribute(this.dataPostNum) * 1) : 0;

        // fire off our main events
        this.events();

    }
    
    // init main events
    events(){

        // make sure we have our target container and button
        if(this.targetContainer && this.button){

            // check if we have more posts
            if(this.postsAvailable()){

                // add click event 
                this.button.addEventListener("click", this.getPosts.bind(this));

            // no posts
            }else{

                // return silently
                return;
                
            }

        }

    }

    // check if we have more posts available
    postsAvailable(){

        // get list of posts
        const currentPostLoad =  (this.targetContainer && this.postClass) ? this.targetContainer.querySelectorAll(`.${this.postClass}`).length : null;

        // return boolean  if current posts on screen are less than total posts for current category 
        if((currentPostLoad !== null)&&(currentPostLoad < this.totalPosts)){

            // remove hide class (just in case from parent as well)
            this.button.parentNode.classList.remove(this.hide);
            this.button.classList.remove(this.hide);

            // return true
            return true;

        }else{

            // add hide class (just in case from parent as well)
            this.button.parentNode.classList.add(this.hide);
            this.button.classList.add(this.hide);

            // return false
            return false;

        }    

    }

    // ajax for more posts -- if none found die silently
    getPosts(e){
        
        // prevent default
        e.preventDefault();

        // make sure we have something to get still
        if(!this.postsAvailable()) return;

        // add loading gif
        this.button.classList.add(this.loading); 

        // get total current post load and set offset
        const offset = (this.targetContainer && this.postClass) ? this.targetContainer.querySelectorAll(`.${this.postClass}`).length : -1;

        // setup data
        const data = new FormData();

        // get current post type
        data.append("postType", this.postType);

        // on load count
        data.append("postsPerPage", this.initialPostLoad);
        
        // make sure we have data
        if(this.nonce && this.nonce[0]) data.append("wp_nonce", this.nonce[0].value);
        
        // get amount of current posts
        data.append("offset", offset);

        // send ajax
        this.ajax({
            action:"listPosts",
            loading:this.button,
            data:data
        // success
        }).then((results) => {

            //parse results
            results = JSON.parse(results);
            
            // ERROR: die silently but remove button
            if(results.error){
                
                //display msg
                for(const key in results.error) {
                    if(Object.hasOwnProperty.call(results.error, key)){
                        console.log(`%c ${results.error[key]}`, 'background:#f00; color:#fff');            
                    }
                }

                // remove show more button
                this.button.remove();

                // return
                return;

            } 

            // check for success and target container
            // if nothing found die silently
            if(results.success && (results.success.length > 0) && this.targetContainer){

                // loop thru success results
                for(const key in results.success){
                    
                    // create temp container
                    const tmpContainer = document.createElement('div');
                    
                    // string to html object conversion
                    tmpContainer.innerHTML = results.success[key];

                    // append posts (html object) to target container
                    this.targetContainer.appendChild(tmpContainer.children[0]);

                }

            }

            // check if posts are still available
            this.postsAvailable();

        // catch ajax error
        }).catch((err) => {
            
            //display msg
            console.log(`%c ${err}`, 'background:#f00; color:#fff');

        });

    }
    
}   

// export
export default MorePosts;